import { render, staticRenderFns } from "./EmployeeHistory.vue?vue&type=template&id=82fa5aa8&scoped=true"
import script from "./EmployeeHistory.vue?vue&type=script&lang=js"
export * from "./EmployeeHistory.vue?vue&type=script&lang=js"
import style0 from "./EmployeeHistory.vue?vue&type=style&index=0&id=82fa5aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fa5aa8",
  null
  
)

export default component.exports